import { useQuery } from '@tanstack/react-query';
import { useSurveyTemplate } from './useSurveyTemplates';
import type { GeneratedQuestion } from '@/contexts/SurveyContext';

export const useSurveyTemplateGeneration = (templateId: string | null) => {
  const { data: template, isLoading: isTemplateLoading } = useSurveyTemplate(templateId || '');

  return useQuery({
    queryKey: ['survey-template-generation', templateId],
    queryFn: async (): Promise<GeneratedQuestion[]> => {
      
      if (!template || !template.questions) {
        return [];
      }


      // Convert survey template questions to the GeneratedQuestion format
      const generatedQuestions: GeneratedQuestion[] = template.questions.map((question, index) => ({
        id: question.id,
        type: question.question_type?.name || 'text',
        category: question.focus_areas?.[0]?.name || 'General',
        question: question.question_text,
        options: question.options ? (Array.isArray(question.options) ? question.options : []) : undefined,
        scale: question.question_type?.name === 'scale' || question.question_type?.name === 'likert' 
          ? { min: 1, max: 5 }
          : undefined
      }));

      return generatedQuestions;
    },
    enabled: !!templateId && !!template && !isTemplateLoading,
  });
};